(function (w) {

    //expose global object
    w.compareProduct = ProductCompareViewModel;

    //product data
    function Product(id, image) {
        var self = this;
        //self.id = ko.observable(id);
        //self.image = ko.observable(image);
        self.id = id; 
        self.image = image;
    }

    function ProductCompareViewModel() {
        var self = this;
        self.maxItemsCount = ko.observable(5);
        self.products = ko.observableArray([]).extend({ cookie: 'compareProducts' });

        self.removeProduct = function (productItem) {
            self.products.remove(function (product) {
                return product.id === productItem.id;
            });
            //TODO This works, but with jQuery selector
            $('#' + productItem.id + '').attr('class', 'compare unchecked');
            //Cookies.set('compareProducts', ko.toJSON(self.products()));
        };

        self.addProduct = function (data, event) {
            var product = new Product(event.target.id, $('#' + event.target.id + '').attr('data-val'));

            var matchingProduct = ko.utils.arrayFirst(self.products(), function (productItem) {
                return productItem.id === product.id;
            });

            if (!matchingProduct) {
                if (self.products().length < self.maxItemsCount()) {
                    self.products.push(product);
                    event.target.className = "compare checked";
                    // Cookies.set('compareProducts', ko.toJSON(self.products()));
                }
            } else {
                self.removeProduct(product);
            }
        };
    };

    $(document).ready(function () {
        ko.bindingHandlers.fadeVisible = {
            update: function (element, valueAccessor) {
                var value = valueAccessor();
                ko.unwrap(value) ? $(element).fadeIn(800) : $(element).fadeOut(0);
            }
        };
        var viewModel = new ProductCompareViewModel();

        viewModel.removeProductCookie = function (data, event) {
            viewModel.removeProduct(new Product(event.target.id));
            window.location.reload();
            //stay on the same page
            return false;
        }
        
        ko.applyBindings(viewModel);
    });

})(this);